import { createBrowserRouter, RouterProvider } from "react-router";

import "./App.css";

import { lazy, Suspense } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { X } from "lucide-react";
import { useModalStore } from "./_store/useModalStore";
import AppLayout from "./routes/outlets/Applayout";
import Loader from "./pages/Loader";

const Home = lazy(() => import("@/pages/Home"));
const Pricing = lazy(() => import("@/pages/Pricing"));
const ContactModal = lazy(() => import("@/components/common/ContactModal"));
const Terms = lazy(() => import("@/pages/policy/Terms"));
const PrivacyPolicy = lazy(() => import("@/pages/policy/Privacy"));
const Solutions = lazy(() => import("@/pages/Solutions"));
const Agents = lazy(() => import("@/pages/Agents"));
const Result = lazy(() => import("@/pages/Result"));

const router = createBrowserRouter([
  {
    path: "/",
    element: <AppLayout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/pricing",
        element: <Pricing />,
      },
      {
        path: "/terms",
        element: <Terms />,
      },
      {
        path: "/privacy",
        element: <PrivacyPolicy />,
      },
      {
        path: "/solutions",
        element: <Solutions />,
      },
      {
        path: "/agents",
        element: <Agents />,
      },
      {
        path: "l0",
        element: <Result />,
      }
    ],
  },
]);

function App() {
  const isOpenContactModal = useModalStore((state) => state.open);
  const setOpen = useModalStore((state) => state.setOpen);

  return (
    <>
      <Suspense fallback={<Loader />}>
        <RouterProvider router={router} />
      </Suspense>
      <Dialog
        open={isOpenContactModal}
        onOpenChange={() => setOpen(!isOpenContactModal)}
      >
        <DialogContent
          icon={
            <span className="block px-2 py-2 rounded-full bg-white/30">
              <X color="white" />
            </span>
          }
        >
          <ContactModal />
        </DialogContent>
      </Dialog>
    </>
  );
}

export default App;
